export interface IPropertyObject {
  propertyRoleName: string;
  protocolConfig: IProtocolObject[];
}

export interface IProtocolObject {
  fieldName: string;
  inputType: EInputType;
  editable: boolean;
  value: string | number;
  options?: IOption[];
  validation?: IValidation[];
  hasError?: boolean;
  errorMsg?: string;
  isUnique?: boolean;
}

export interface IOption {
  text: string;
  value: string;
}

export interface IValidation {
  type: string;
  value: number;
}

export enum EInputType {
  text = 'text',
  number = 'number',
  select = 'select'
}

export interface IPayloadProperty {
  propertyName: string;
  protocolConfig: {
    protocolType: string;
    protocolObject: IPayloadProtocolObject;
  };
}

export enum EEquipmentType {
  Meter = 'Meter'
}
export enum EDeviceType {
  ModbusElectricMeter = 'ModbusElectricMeter',
  ModbusVRF = 'ModbusVRF'
}

export interface ITemplateDetail {
  id: string;
  name: string;
  templateName: string;
  vendorName: string;
  modelName: string;
  isBuiltInTemplate: boolean;
  templateConfiguration: {
    propertyAttributes: IPayloadProperty[];
  };
}
export interface ICreateTemplatePayoad {
  id: string;
  deviceType: string;
  templateName: string;
  vendorName: string;
  modelNames: string[];
  templateConfiguration: {
    propertyAttributes: IPayloadProperty[];
  };
}

export interface IPayloadProtocolObject {
  objectName: string;
  objectType: string;
  address: number;
  unitId: number;
  bitunpack: number;
  bitRange: number;
  propName: string;
  propDataType: string;
  propValue: number;
  msgType: string;
  isMultiState: number;
  scalingOperation: number;
  scalingFactor: number;
  byteOrder: string;
}
